/**
 * Created by meirr on 9/11/16.
 */
define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var DateTimeUtils = require('web-agent-utils/DateTimeUtils');
    var BaseFilterItem = require('web-agent-components/BaseFilterItemViewController');
    var TimeFrameViewController = require('web-agent-components/TimeFrameViewController');

    /**
     * @implements {BaseFilterItem}
      */
    var FilterItemTimeFrame = BaseFilterItem.extend({

        NowKey: DateTimeUtils.NOW_KEY,
        LPClassesMap: {
            timeFrameFilterItem: ".filter_item_timeframe",
            dateInput: ".dateInput",
            timeInput: ".timeInput",
            datePicker: ".date-picker-item",
            filterArea: '.lpview_filterArea',
            tableContainer: ".list_table_container"
        },
        LPTemplatesFiles: {
            timeFrameTemplate: 'LP_filter_full_table_time_frame.html'
        },

        initialize: function (constructorData) {

            var filterOptions = lpUtils.cloneObject(constructorData);
            filterOptions.scrollableContainer = this.LPClassesMap.tableContainer;

            if(_.isNumber(constructorData.maxDaysDuration)) {
                filterOptions.maxDaysDuration = constructorData.maxDaysDuration;
            } else if(_.isNumber(constructorData.maxMonthsDuration)) {
                filterOptions.maxDaysDuration = DateTimeUtils.getLastMonthsDurationInDays(constructorData.maxMonthsDuration);
            } else {
                filterOptions.maxDaysDuration = 30;  //default
            }

            var timeFrameTemplate = require('web-agent-templates/' + this.LPTemplatesFiles.timeFrameTemplate);
            // var timeFrameTemplate = lpUtils.loadResource(this.LPTemplatesFiles.timeFrameTemplate);
            this.view  = this.createView({template: timeFrameTemplate, doNotAddChild: true});
            this.timeFrameVC = new TimeFrameViewController(filterOptions);
            this.datePickerVisible = false;
            this.anyClickCallback = this._onAnyClick.bind(this);
        },
        events: function () {
            this.timeFrameVC.bindViewEvent({selector: this.LPClassesMap.dateInput, DOMEvent: "click", callback: this._onDateInputClicked.bind(this)});
        },
        render: function () {
            this.addViewController({viewController: this.timeFrameVC, target: this.LPClassesMap.timeFrameFilterItem});
            this.timeFrameVC.hideDatePickers();
        }
    });

    /**
     * @override
     * @returns {{from: number, to: number}}
     */
    FilterItemTimeFrame.prototype.getValue = function() {
        var uiDate = this.timeFrameVC.getUIData();
        if(uiDate.endDate === this.NowKey){
            this.nowDate = new Date();
        } else {
            this.nowDate = null;
            uiDate.endDate = uiDate.endDate.getTime();
        }
        return {
            from: uiDate.startDate.getTime(),
            to: uiDate.endDate
        };
    };

    /**
     * @override
     */
    FilterItemTimeFrame.prototype.updateFilterUI = function(filterData) {
        var isNow = false;

        if(filterData && /*this.nowDate && this.nowDate.getTime()*/this.NowKey === filterData.to) {
               isNow = true;
        }

        if(filterData && _.isNumber(filterData.from) && (_.isNumber(filterData.to) || isNow)) {
            this.timeFrameVC.setUIData({startDate: new Date(filterData.from), endDate: (isNow ? this.NowKey : new Date(filterData.to))});
            this.timeFrameVC.refresh();
        } else {
            this.timeFrameVC.reset();
        }
    };

    /**
     * Handler for date input click
     * @param {Event} event
     * @private
     */
    FilterItemTimeFrame.prototype._onDateInputClicked = function(event) {
        //toggle datepickers visibility
        event.stopPropagation();
        this._setDatePickersVisibility(!this.datePickerVisible);
    };

    /**
     * Handler for any click in the document
     * @param {MouseEvent} event
     * @private
     */
    FilterItemTimeFrame.prototype._onAnyClick = function(event) {
        var elementUnderMouse = document.elementFromPoint(event.clientX, event.clientY);
        if(!this._isDatePickerInnerElement(elementUnderMouse)) {
            this._setDatePickersVisibility(false);
        }
    };

    /**
     * Toggle date pickers visibility
     * @param {Boolean} isVisible
     * @private
     */
    FilterItemTimeFrame.prototype._setDatePickersVisibility = function(isVisible) {
        if(isVisible) {
            this.timeFrameVC.showDatePickers();
            document.addEventListener('click', this.anyClickCallback);
        } else {
            this.timeFrameVC.hideDatePickers();
            document.removeEventListener('click', this.anyClickCallback);
        }
        this.datePickerVisible = isVisible;
    };

    /**
     * Checks if element is a child of a datepicker
     * @param {Element} element
     * @returns {boolean}
     * @private
     */
    FilterItemTimeFrame.prototype._isDatePickerInnerElement = function(element) {
        return !!this.getParentElementBySingleSelector(element, this.LPClassesMap.datePicker);
    };


    return FilterItemTimeFrame;

});
